<template>
    <div class="calendar" v-bind:class="{'calendar-line-6': days.length == 6 && days[5].length > 0, 'calendar-line-5': days.length == 5 || (days.length == 6 && days[5].length == 0), 'calendar-line-4': days.length == 4}">
        <!-- 切换条 -->
        <div class="calendar-tools dsp-flex">
            <div class="calendar-prev" @click="prev">
                <i class="iconfont icon-xiangzuo"></i>
                <span class="text">上月</span>
            </div>
            <div class="calendar-info" @click.stop="changeYear">
                <div class="year">
                    <span v-if="currentTab == 1">{{year+'年'+(month+1)+'月'+day+'日  '+hour+':'+minute}}</span>
                    <span v-if="currentTab == 2 && lunarDate">{{lunarDate.IYearCn+'年'+lunarDate.IMonthCn+lunarDate.IDayCn+'  '+lunarDate.time}}</span>
                    <i class="iconfont icon-down"></i>
                </div>
            </div>
            <div class="calendar-next"  @click="next">
                <span class="text">下月</span>
                <i class="iconfont icon-xiangyou"></i>
            </div>
        </div>
        <!-- 日历表 -->
        <table>
            <thead>
                <tr>
                    <td class="week"><div class="week-box"></div></td>
                    <td v-for="week in weeks" class="week">
                        <div class="week-box">{{week}}</div>
                    </td>
                    <td class="week"><div class="week-box"></div></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(day,k1) in days" style="{'animation-delay',(k1*30)+'ms'}">
                    <td v-if="day.length > 0"></td>
                    <td v-for="(child,k2) in day" :class="{'selected':child.selected,'disabled':child.disabled && !showDisabled, 'hide':child.disabled && showDisabled}" @click="select(k1,k2,$event,child)">
                        <div class="td-box">
                            <div class="ganzhi">{{child.gz}}</div>
                            <span :class="{'red':k2==0||k2==6||((child.isLunarFestival||child.isGregorianFestival) && lunar)}">{{child.day}}</span>
                            <div class="text" v-if="child.eventName!=undefined">{{child.eventName}}</div>
                            <div class="text" :class="{'isJieQi':child.isJieQi,'isLunarFestival':child.isLunarFestival,'isGregorianFestival':child.isGregorianFestival,'isSpecialFestival':child.isSpecialFestival,'max-text':child.lunar.length>3}" v-if="lunar">{{child.lunar.length > 6 ? child.lunar.replace('节', '') : child.lunar}}</div>
                        </div>
                    </td>
                    <td v-if="day.length > 0"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { CALENDAR } from '../../modules/calendar/calendar.js'
import { FORMAT } from '../../modules/data/core/format.js'
import { PAIPAN } from '../../modules/data/core/paipan.js'
import { COLLATE_DATA_MANAGER } from '../../modules/data/index.js'
import { UTILS } from '../../modules/utils/index.js'
export default {
    name: 'CalendarPanel',
    computed: {
        currentTab() {
            return this.$store.state.calendar.currentTab
        }
    },
    props: {
        // 默认日期
        value: {
            type: Array,
            default: function(){
                return []
            }
        },
        // 是否小于10补零
        zero:{
            type: Boolean,
            default: false
        },
        // 屏蔽的日期
        disabled:{
            type: Array,
            default: function(){
                return []
            }
        },
        // 展示屏蔽的日期
        showDisabled: {
            type: Boolean,
            default: true
        },
        // 是否显示农历
        lunar: {
            type: Boolean,
            default: false
        },
        // 自定义星期名称
        weeks: {
            type: Array,
            default:function(){
                return window.navigator.language.toLowerCase() == "zh-cn"?['日', '一', '二', '三', '四', '五', '六']:['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
            }
        },
        // 自定义月份
        months:{
            type: Array,
            default:function(){
                return window.navigator.language.toLowerCase() == "zh-cn"?['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']:['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            }
        },
        // 自定义事件
        events:  {
            type: Object,
            default: function(){
                return {}
            }
        },
    },
    data() {
        return {
            years:[],
            year: 0, month: 0, day: 0,
            hour: 0,
            minute: 0,
            lunarDate: {},
            lYear: 0, lMonth: 0, lDay: 0, isLeap: 0,
            curdayObj: {},
            days: [],
            today: [],
            festival:{
                lunar:{
                    "1-1":"春节",
                    "1-15":"元宵",
                    "2-2":"龙头节",
                    "5-5":"端午",
                    "7-7":"七夕",
                    "7-15":"中元节",
                    "8-15":"中秋",
                    "9-9":"重阳",
                    "10-1":"寒衣节",
                    "10-15":"下元节",
                    "12-8":"腊八节",
                    "12-23":"祭灶节",
                    "12-30":"除夕",
                },
                gregorian:{
                    "1-1":"元旦",
                    "2-14":"情人节",
                    "3-8":"妇女节",
                    "3-12":"植树节",
                    "3-15":"消权日",
                    "4-1":"愚人节",
                    "4-22":"地球日",
                    "5-1":"劳动节",
                    "5-4":"青年节",
                    "6-1":"儿童节",
                    "7-1":"建党节",
                    "8-1":"建军节",
                    "9-10":"教师节",
                    "10-1":"国庆节",
                    "10-31":"万圣节",
                    "11-11":"光棍节",
                    "12-24":"平安夜",
                    "12-25":"圣诞节",
                },
                special: {
                    "month":[5,6,11],
                    "5":{key: 5, index: 2, week: 0, text: '母亲节'},
                    "6":{key: 6, index: 3, week: 0, text: '父亲节'},
                    "11":{key: 11, index: 4, week: 4, text: '感恩节'},
                }
            },
            jieqi: {}
        }
    },
    watch:{
        events(){
            this.render(this.year,this.month)
        },
        value(){
            this.init();
        }
    },
    mounted() {
        this.init();
        this.$bus.on('selectCalendar', this.selectCalendar);
    },
    destroyed() {
        this.$bus.off('selectCalendar', this.selectCalendar);
    },
    methods: {
        init(){
            let now = new Date();
            this.year = now.getFullYear()
            this.month = now.getMonth()
            this.day = now.getDate()
            this.hour = UTILS.getTimeStrByInt(now.getHours());
            this.minute = UTILS.getTimeStrByInt(now.getMinutes());
            if (this.value.length>0) {
                this.year = parseInt(this.value[0])
                this.month = parseInt(this.value[1]) - 1
                this.day = parseInt(this.value[2]) 
            }

            // 处理农历时辰
            var curDay = CALENDAR.solar2lunar(this.year, this.month+1, this.day);
            this.lunarDate = Object.assign(curDay, {
                time: FORMAT.getShiChenByNumber(this.hour)
            })
            this.lYear = this.lunarDate.lYear;
            this.lMonth = this.lunarDate.lMonth;
            this.lDay = this.lunarDate.lDay;
            this.isLeap = CALENDAR.leapMonth(this.lYear) != 0 && this.lMonth == CALENDAR.leapMonth(this.lYear) ? 1 : 0;

            this.render(this.year, this.month)
        },
        // 渲染日期
        render(y, m) {
            let firstDayOfMonth = new Date(y, m, 1).getDay()         //当月第一天
            let lastDateOfMonth = new Date(y, m + 1, 0).getDate()    //当月最后一天
            let lastDayOfLastMonth = new Date(y, m, 0).getDate()     //最后一月的最后一天
            this.year = y
            let seletSplit = this.value
            let i, line = 0,temp = [],nextMonthPushDays = 1
            
            this.jieqi = CALENDAR.getJieQi(y, m+1, 15);
            for (i = 1; i <= lastDateOfMonth; i++) {
                let day = new Date(y, m, i).getDay() //返回星期几（0～6）
                let k
                // 第一行
                if (day == 0) {
                    temp[line] = []
                } else if (i == 1) {
                    temp[line] = []
                    k = lastDayOfLastMonth - firstDayOfMonth + 1
                    for (let j = 0; j < firstDayOfMonth; j++) {
                        // console.log("第一行",lunarYear,lunarMonth,lunarValue,lunarInfo)
                        temp[line].push(Object.assign(
                            {day: k,disabled: true},
                            this.getLunarInfo(this.computedPrevYear(),this.computedPrevMonth(true),k),
                            this.getEvents(this.computedPrevYear(),this.computedPrevMonth(true),k),
                            this.getGanZhi(this.computedPrevYear(),this.computedPrevMonth(true),k)
                        ))
                        k++;
                    }
                }
       
                // console.log(this.lunar(this.year,this.month,i));
                
                let chk = new Date()
                let chkY = chk.getFullYear()
                let chkM = chk.getMonth()
                // 匹配上次选中的日期
                if (parseInt(seletSplit[0]) == this.year && parseInt(seletSplit[1]) - 1 == this.month && parseInt(seletSplit[2]) == i) {
                    // console.log("匹配上次选中的日期",lunarYear,lunarMonth,lunarValue,lunarInfo)
                    temp[line].push(Object.assign(
                        {day: i,selected: true},
                        this.getLunarInfo(this.year,this.month+1,i),
                        this.getEvents(this.year,this.month+1,i),
                        this.getGanZhi(this.year,this.month+1,i),
                    ))
                    this.today = [line, temp[line].length - 1]
                }else if (chkY == this.year && chkM == this.month && i == this.day && this.value == "") {
                    // 没有默认值的时候显示选中今天日期
                    // console.log("今天",lunarYear,lunarMonth,lunarValue,lunarInfo)
                    temp[line].push(Object.assign(
                        {day: i,selected: true},
                        this.getLunarInfo(this.year,this.month+1,i),
                        this.getEvents(this.year,this.month+1,i),
                        this.getGanZhi(this.year,this.month+1,i),
                    ))
                    this.today = [line, temp[line].length - 1]
                }else{
                    // 普通日期
                    // console.log("设置可选范围",i,lunarYear,lunarMonth,lunarValue,lunarInfo)
                    let options = Object.assign(
                        {day: i,selected:false},
                        this.getLunarInfo(this.year,this.month+1,i),
                        this.getEvents(this.year,this.month+1,i),
                        this.getGanZhi(this.year,this.month+1,i),
                    )
                    if (this.disabled.length>0){
                        if (this.disabled.filter(v => {return this.year === v[0] && this.month === v[1]-1 && i === v[2] }).length>0) {
                            options.disabled = true
                        }
                    }
                    temp[line].push(options)
                }
                // 到周六换行
                if (day == 6 && i < lastDateOfMonth) {
                    line++
                }else if (i == lastDateOfMonth) {
                    // line++
                    let k = 1
                    for (let d=day; d < 6; d++) {
                         // console.log(this.computedNextYear()+"-"+this.computedNextMonth(true)+"-"+k)
                        temp[line].push(Object.assign(
                            {day: k,disabled: true},
                            this.getLunarInfo(this.computedNextYear(),this.computedNextMonth(true),k,line),
                            this.getEvents(this.computedNextYear(),this.computedNextMonth(true),k),
                            this.getGanZhi(this.computedNextYear(),this.computedNextMonth(true),k),
                        ))
                        k++
                    }
                    // 下个月除了补充的前几天开始的日期
                    nextMonthPushDays=k
                }
            } //end for

            // console.log(this.year+"/"+this.month+"/"+this.day+":"+line)
            // 补充第六行让视觉稳定:::暂时可以不要
            // if(line<=5 && nextMonthPushDays>0){
            //     // console.log({nextMonthPushDays:nextMonthPushDays,line:line})
            //     for (let i = line+1; i<=5; i++) {
            //         temp[i] = []
            //         let start=nextMonthPushDays+(i-line-1)*7
            //         for (let d=start; d <= start+6; d++) {
            //             temp[i].push(Object.assign(
            //                 {day: d,disabled: true},
            //                 this.getLunarInfo(this.computedNextYear(),this.computedNextMonth(true),d),
            //                 this.getEvents(this.computedNextYear(),this.computedNextMonth(true),d),
            //                 this.getGanZhi(this.computedNextYear(),this.computedNextMonth(true),d),
            //             ))
            //         }  
            //     }
            // }
            this.days = temp;
        },
        renderLunar(isLeap) {
            var firstDay = CALENDAR.lunar2solar(this.lYear, this.lMonth, 1, isLeap),
                selectDay = CALENDAR.lunar2solar(this.lYear, this.lMonth, this.lDay, isLeap);

            this.year = selectDay.cYear;
            this.month = selectDay.cMonth-1;
            this.day = selectDay.cDay;
            // 处理节气
            var curM = this.day >= 15 ? this.month+2 : this.month+1;
                curM = curM > 12 ? 1 : curM;
            this.jieqi = CALENDAR.getJieQi(this.year, curM, 1);
            // 处理闰月中间值
            this.isLeap = CALENDAR.leapMonth(this.lYear) != 0 && this.lMonth == CALENDAR.leapMonth(this.lYear) ? 1 : 0;
            this.isLeap = this.isLeap == 1 && isLeap == 0 ? 0 : this.isLeap;
            // 处理时辰
            this.lunarDate = Object.assign(selectDay, {
                time: FORMAT.getShiChenByNumber(this.hour)
            });
            // console.log('renderLunar-------', this.lYear, this.lMonth, this.lDay, isLeap, selectDay, this.lunarDate);
                
            let i, line = 0, temp = [];
            var oYear, oMonth, oDay, nDay;
            let seletSplit = this.value
            // 第一行:先按照到二十九算，然后再处理最后一天三十；
            for(i = 0; i < 29; i++) {
                let newDate = new Date(firstDay.cYear, firstDay.cMonth-1, firstDay.cDay+i),
                    day = newDate.getDay(), tempDay = 0;
                tempDay = newDate.getMonth() == firstDay.cMonth ? newDate.getDate() : tempDay;
                tempDay = newDate.getMonth() == 0 && firstDay.cMonth == 12 ? newDate.getDate() : tempDay;
                // console.error('day---', firstDay.cMonth, newDate.getMonth(), day, tempDay)
                if(day == 0) {
                    temp[line] = [];
                }else if(i == 0) {
                    temp[line] = [];
                    for(var j = 0; j < firstDay.nWeek; j++) {
                        temp[line].push(Object.assign(
                            {day: firstDay.cDay-firstDay.nWeek+j,disabled: true},
                            this.getLunarInfo(firstDay.cYear, firstDay.cMonth, firstDay.cDay-firstDay.nWeek+j),
                            this.getEvents(firstDay.cYear, firstDay.cMonth, firstDay.cDay-firstDay.nWeek+j),
                            this.getGanZhi(firstDay.cYear, firstDay.cMonth, firstDay.cDay-firstDay.nWeek+j)
                        ));
                    }
                }
                // console.error('-------', i, day, temp, seletSplit, firstDay.cDay);
                oDay = tempDay == 0 ? firstDay.cDay+i : tempDay;
                nDay = tempDay == 0 ? false : true;
                oMonth = tempDay == 0 ? firstDay.cMonth : firstDay.cMonth+1;
                oYear = oMonth > 12 ? firstDay.cYear+1 : firstDay.cYear;
                oMonth = oMonth > 12 ? oMonth-12 : oMonth;
                let options = Object.assign(
                    {day: oDay, next: nDay, selected:false},
                    this.getLunarInfo(oYear, oMonth, oDay),
                    this.getEvents(oYear, oMonth, oDay),
                    this.getGanZhi(oYear, oMonth, oDay),
                )
                temp[line].push(options)

                // 处理换行
                if(day == 6) {
                    line++;
                    temp[line] = [];
                }
            }
            var lastLunarDay = CALENDAR.solar2lunar(oYear, oMonth, oDay+1);
            // 处理最后一条数据:如果有三十天的话就加上最后这一天三十
            console.log('lastLunarDay=======', oYear, oMonth, oDay, lastLunarDay, temp, temp[line])
            if(lastLunarDay.lDay == 30) {
                var obj = Object.assign(
                    {day: oDay+1, next: true, selected: false},
                    this.getLunarInfo(oYear, oMonth, oDay+1),
                    this.getEvents(oYear, oMonth, oDay+1),
                    this.getGanZhi(oYear, oMonth, oDay+1)
                )
                temp[line].push(obj);
            }

            this.days = temp
        },
        computedPrevYear(){
            let value=this.year
            if(this.month-1<0){
                value--
            }
            return value
        },
        computedPrevMonth(isString){
            let value=this.month
            if(this.month-1<0){
                value=11
            }else{
                value--
            }
            // 用于显示目的（一般月份是从0开始的）
            if(isString){
                return value+1
            }
            return value
        },
        computedNextYear(){
            let value=this.year
            if(this.month+1>11){
                value++
            }
            return value
        },
        computedNextMonth(isString){
            let value=this.month
            if(this.month+1>11){
                value=0
            }else{
                value++
            }
            // 用于显示目的（一般月份是从0开始的）
            if(isString){
                return value+1
            }
            return value
        },
        // 获取农历信息
        getLunarInfo(y,m,d){
            let lunarInfo = CALENDAR.solar2lunar(y,m,d);
            // console.log('getLunarInfo-------', lunarInfo);
            let lunarValue = lunarInfo.lDay == 1 ? lunarInfo.IMonthCn : lunarInfo.IDayCn;
            let isJieQi=false
            let isLunarFestival=false
            let isGregorianFestival=false
            let isSpecialFestival=false
            // 处理节气
            if(this.jieqi[m+"-"+d]!=undefined){
                isJieQi = true;
                lunarValue = this.jieqi[m+"-"+d]
            }
            // 处理农历节日
            var lM = lunarInfo.lMonth, lD = lunarInfo.lDay;
            if(lM == 12 && lD >= 29) {  //特殊处理除夕
                var isBig = CALENDAR.checkLunarBigMonth(lunarInfo.lYear, lM);
                lD = isBig ? lD : 30;
            }
            if(this.festival.lunar[lM+"-"+lD]!=undefined){
                isLunarFestival = true;
                if(isJieQi) {
                    lunarValue = lunarValue + '|' + this.festival.lunar[lM+"-"+lD]
                }else {
                    lunarValue = this.festival.lunar[lM+"-"+lD];
                }
            }
            // 处理公历节日
            if(this.festival.gregorian[m+"-"+d]!=undefined){
                isGregorianFestival = true;
                if((isJieQi && !isLunarFestival) || (!isJieQi && isLunarFestival)) {
                    lunarValue = lunarValue + '|' + this.festival.gregorian[m+"-"+d]
                }else if(!isJieQi && !isLunarFestival) {
                    lunarValue = this.festival.gregorian[m+"-"+d]
                }
            }
            // 处理公历的特殊节日:母亲节、父亲节、感恩节
            if(this.festival.special.month.indexOf(m) >= 0) {
                var specialData = this.festival.special[parseInt(m)];
                // var specialDay = CALENDAR.getFestivalByMonthWeek(y, m, d, specialData);
                var specialDay = CALENDAR.getSpecialFestivalByMonthWeek(y, m, d, specialData);
                if(specialDay != -1) {
                    console.log('special------', specialDay, y, m, d, specialData.text)
                    isSpecialFestival = true;
                    if((isJieQi && !isLunarFestival) || (!isJieQi && isLunarFestival)) {
                        lunarValue = lunarValue + '|' + specialData.text;
                    }else if(!isJieQi && !isLunarFestival) {
                        lunarValue = specialData.text;
                    }
                }
            }
        
            return {
                lunar: lunarValue,
                lunarNum: lunarInfo.lDay,
                isJieQi: isJieQi,
                isLunarFestival: isLunarFestival,
                isGregorianFestival: isGregorianFestival,
                isSpecialFestival: isSpecialFestival
            }
        },
        // 获取自定义事件
        getEvents(y,m,d){
            if(Object.keys(this.events).length==0)return false;
            let eventName=this.events[y+"-"+m+"-"+d]
            let data={}
            if(eventName!=undefined){
                data.eventName=eventName
            }
            return data
        },
        // 获取干支
        getGanZhi(y,m,d) {
            return {
                gz: CALENDAR.getGanZhi(y, m, d)
            }
        },
        // 上月
        prev(e) {
            e.stopPropagation()
            if(this.currentTab == 1) {
                if (this.month == 0) {
                    this.month = 11
                    this.year = parseInt(this.year) - 1
                } else {
                    this.month = parseInt(this.month) - 1
                }
                this.render(this.year, this.month)
                this.$emit('selectMonth',this.month+1,this.year)
                this.$emit('prev',this.month+1,this.year)
                this.days.forEach(v => {
                    let day=v.find(vv => {
                        return vv.day==this.day && !vv.disabled
                    })
                    if(day!=undefined ){
                    day.selected=true  
                    }
                })
            }else if(this.currentTab == 2) {
                if (this.lMonth == 1) {
                    this.lMonth = 12
                    this.lYear = parseInt(this.lYear) - 1
                } else {
                    this.lMonth = parseInt(this.lMonth) - 1
                }
                var leap = this.lMonth == CALENDAR.leapMonth(this.lYear) && this.isLeap == 0 ? 1 : 0;
                this.lMonth = this.isLeap == 1 && leap == 0 ? this.lMonth + 1 : this.lMonth;
                // console.log('prev=========', this.lMonth, CALENDAR.leapMonth(this.lYear), this.isLeap, leap)
                this.renderLunar(leap);
                // this.isLeap = this.isLeap == 1 ? 0 : this.isLeap;
                // 遍历当前日找到选中
                this.days.forEach(v => {
                    let day=v.find(vv => {
                        return vv.lunarNum==this.lunarDate.lDay && !vv.disabled;
                    })
                    if(day!=undefined ){
                        day.selected=true  
                    }
                })
            }
            this.updateYiJi({}, true);
            // 遍历当前日找到选中
            // console.log('pre-------', this.day, this.days, this.currentTab)
        },
        //  下月
        next(e) {
            e.stopPropagation()
            if(this.currentTab == 1) {
                if (this.month == 11) {
                    this.month = 0
                    this.year = parseInt(this.year) + 1
                } else {
                    this.month = parseInt(this.month) + 1
                }
                this.render(this.year, this.month)
                this.$emit('selectMonth',this.month+1,this.year)
                this.$emit('next',this.month+1,this.year)
                // 遍历当前日找到选中
                this.days.forEach(v => {
                    let day=v.find(vv => {
                        return vv.day==this.day && !vv.disabled;
                    })
                    if(day!=undefined ){
                    day.selected=true  
                    }
                })
            }else if(this.currentTab == 2) {
                if (this.lMonth == 12) {
                    this.lMonth = 1
                    this.lYear = parseInt(this.lYear) + 1
                } else {
                    this.lMonth = parseInt(this.lMonth) + 1
                }
                var leapM = CALENDAR.leapMonth(this.lYear);
                var leap = this.lMonth == leapM && this.isLeap == 1 ? 1 : 0;
                // console.log('next=========', this.lMonth, leapM, this.isLeap, leap)
                if(leapM != 0 && this.lMonth-1 == leapM && this.isLeap == 0 && leap == 0) {
                    this.lMonth = this.lMonth - 1;
                    this.renderLunar(1);
                }else {
                    this.renderLunar(leap);
                }
                // console.log('next-------', this.day, this.days, this.currentTab, this.lunarDate)
                // 遍历当前日找到选中
                this.days.forEach(v => {
                    let day=v.find(vv => {
                        return vv.lunarNum==this.lunarDate.lDay && !vv.disabled;
                    })
                    if(day!=undefined ){
                    day.selected=true  
                    }
                })
            }
            this.updateYiJi({}, true);
        },
        updateYiJi(curday={}, isToday=false) {
            // 手动设置时间
            var year = this.year,
                month = isToday || (this.currentTab == 1 && curday && !curday.next) ? this.month+1 : this.month;
            year = month > 12 || month <= 0 ? year+1 : year;
            month = this.currentTab == 2 && curday && curday.next ? month+1 : month;
            month = month > 12 || month <= 0 ? 1 : month;
            var timeStr = UTILS.getTimeStrByInt(this.year) + '/' + UTILS.getTimeStrByInt(month) + '/' + UTILS.getTimeStrByInt(this.day) + ' ' + UTILS.getTimeStrByInt(this.hour) + ':' + UTILS.getTimeStrByInt(this.minute) + ':00';
            this.$store.state.calendar.currentCalendarDate = new Date(timeStr);
            console.log('updateYiji-----------', year, month, curday, isToday, timeStr);
            // 处理时辰
            var curDay = CALENDAR.solar2lunar(this.year, month, this.day);
            this.lunarDate = Object.assign(curDay, {
                time: FORMAT.getShiChenByNumber(this.hour)
            })
            // 更新宜忌
            this.$store.dispatch('calendar/initCalendarData');
        },
        // 选中日期
        select(k1, k2, e, curday={}) {
            if (e != undefined) {
                e.stopPropagation()
            }
            if (curday && curday.disabled) {
                return;
            }
            // 取消上次选中
            if (this.today.length > 0) {
                this.days.forEach(v=>{
                    v.forEach(vv=>{
                        vv.selected= false
                    })
                })
            }
            // 设置当前选中天
            this.days[k1][k2].selected = true
            this.day = this.days[k1][k2].day
            this.today = [k1, k2]
            this.curdayObj = curday;
            
            // console.error('select------', curday)
            var month = curday && curday.next ? this.month+1 : this.month;
            this.$emit('select',[this.year,this.zero?this.zeroPad(month):month,this.zero?this.zeroPad(this.days[k1][k2].day):this.days[k1][k2].day])
            this.updateYiJi(curday);
        },
        // 选中某一天
        selectCalendar(params) {
            this.year = params.value ? params.value[0] : this.year;
            this.month = params.value ? params.value[1] : this.month;
            this.day = params.value ? params.value[2] : this.day;
            // console.log('selectCalendar-----', params.value, this.year, this.month, this.day)

            if(params.calType == 1) {
                this.render(this.year, this.month)
                this.$emit('select', [this.year, this.month+1, this.day])
            }else if(params.calType == 2){
                var calObj = CALENDAR.solar2lunar(this.year, this.month+1, this.day);
                this.lYear = calObj.lYear;
                this.lMonth = calObj.lMonth;
                this.lDay = calObj.lDay;
                this.renderLunar(calObj.isLeap);
            }

            // 更新宜忌
            this.updateYiJi({}, params ? true : false);
            // 遍历当前日找到选中
            this.days.forEach(v => {
                let day=v.find(vv => {
                    return vv.day==this.day && !vv.disabled
                })
                if(day!=undefined ){
                  day.selected=true  
                }
            })
        },
        changeYear(){
            this.$store.dispatch('calendar/initCalendarDatePop', {
                year: this.year,
                month: this.month,
                day: this.day
            });
            if(this.currentTab == 2) {
                this.$bus.emit('updateCalendarDatePop', {
                    year: this.year,
                    month: this.month,
                    day: this.day
                })
            }
        },
        selectYear(value){
            this.year=value
            this.render(this.year,this.month)
            // this.$emit('selectYear',value)
        },
        // 日期补零
        zeroPad(n){
            return String(n < 10 ? '0' + n : n)
        },
    }
}
</script>